import { useEffect, useState } from "react";
import { useParams, useNavigate, Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Printer, ArrowLeft, Pencil } from "lucide-react";
import { toast } from "sonner";
import ReferralPreview from "@/components/ReferralPreview";

export default function ReferralView() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [referral, setReferral] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get(`/referrals/${id}`),
      api.get("/print-settings"),
    ]).then(([r, s]) => {
      setReferral(r.data);
      setSettings(s.data || {});
    }).catch(() => toast.error("Could not load referral"));
  }, [id]);

  useEffect(() => {
    if (referral && params.get("print") === "1") {
      setTimeout(() => window.print(), 400);
    }
  }, [referral, params]);

  if (!referral) return <div className="p-8 text-slate-500">Loading...</div>;

  return (
    <div className="p-6 md:p-8" data-testid="referral-view">
      <div className="no-print flex items-center justify-between mb-4 max-w-5xl mx-auto">
        <Button asChild variant="ghost"><Link to="/referrals"><ArrowLeft size={14} className="mr-2" /> Back</Link></Button>
        <div className="flex gap-2">
          <Button onClick={() => window.print()} className="bg-blue-600 hover:bg-blue-700" data-testid="btn-print-referral"><Printer size={14} className="mr-2" /> Print</Button>
        </div>
      </div>
      <div className="bg-slate-100 p-6 rounded-md">
        <ReferralPreview referral={referral} settings={settings} />
      </div>
    </div>
  );
}
